import Rosewood1 from "../Summarecon Bogor/Rosewood.webp"
import Rosewood2 from "../Summarecon Bogor/Rosewood.webp"

const Rosewoodimages =[
    Rosewood1,Rosewood2
]

export default Rosewoodimages;